module.exports = __webpack_public_path__ + "img/frontex.6f6ebce3.png";